import { useContext } from 'react';
import { SatelliteLeadManagementSourceType } from '@zg-rentals/ts-satellite-client';
import { LeadManagementContext } from '../contexts/LeadManagementContextProvider';
import useStreetEasyLeadManagementEnabled from './useStreetEasyLeadManagementEnabled';

/** A landlord whose leads all come through Zillow gains nothing from a source label. */
export function isLeadSourceVisible(
  availableSources: Array<SatelliteLeadManagementSourceType>,
  isStreetEasyLeadManagementEnabled: boolean,
): boolean {
  return isStreetEasyLeadManagementEnabled && availableSources.includes(SatelliteLeadManagementSourceType.STREET_EASY);
}

/** Must be rendered within the LeadManagementContext provider. */
export default function useIsLeadSourceVisible(): boolean {
  const { availableSources } = useContext(LeadManagementContext);
  const isStreetEasyLeadManagementEnabled = useStreetEasyLeadManagementEnabled();
  return isLeadSourceVisible(availableSources, isStreetEasyLeadManagementEnabled);
}
